(() => {
  if (window.__bisGateInit) return;
  window.__bisGateInit = true;

  const apply = () => {
    const product = document.querySelector('product-info[data-update-url="true"]');
    const marker = product?.querySelector('[id^="BIS-"] .bis-state');
    const allowed = product?.dataset.bisPending !== 'true' && marker?.dataset.bisAllowed === 'true';
    document.documentElement.classList.toggle('bis-allowed', allowed);
    document.querySelectorAll('#klaviyo-bis-button-container button, button[data-a11y-identifier^="bis-button-"]').forEach((button) => {
      if (!button.classList.contains('button')) button.classList.add('button', 'button--secondary');
    });
    document.querySelectorAll('sticky-atc').forEach((sticky) => sticky.updateBisTrigger?.());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('product-info:loaded', apply);
  document.addEventListener('shopify:section:load', apply);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, apply);
  }
  new MutationObserver((records) => {
    if (records.some((record) => record.type === 'childList' || record.attributeName === 'data-bis-allowed' || record.attributeName === 'data-bis-pending' || record.attributeName === 'disabled' || record.attributeName === 'aria-disabled')) apply();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-bis-allowed', 'data-bis-pending', 'disabled', 'aria-disabled'],
  });
})();
